<script setup>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
import {onMounted, ref, computed} from "vue";
//axios请求
import {inject} from 'vue'
import {ArrowRight} from '@element-plus/icons-vue'

onMounted(() => {
  showRnaseq();
});
const $axios = inject('$axios')
const rna_seqList = ref([])
const inputText = ref('LOC111050743')
const rna_seqList2 = ref([])
const inputText2 = ref('')
//分页器

// 默认显示第几页
const currentPage = ref(1)
// 个数选择器（可修改）
let pageSizes = [20, 50, 100, 200, 300, 400]
// 默认每页显示的条数（可修改）
const PageSize = ref(20)

// 显示第几页
function handleCurrentChange(val) {
  // 改变默认的页数
  currentPage.value = val
}

function handleSizeChange(val) {
  // 改变每页显示的条数
  PageSize.value = val
  // 注意：在改变每页显示的条数时，要将页码显示到第一页
  currentPage.value = 1
}

function inputInput(e) {
  inputText.value = e.target.value;
  showRnaseq();
}
function inputInput2(e) {
  inputText2.value = e.target.value;
  showRnaseq();
}


function showRnaseq() {
  loadtable1.value = true
  $axios.get('http://bioinfo-sysu.com:8383/api/Gene_search?input=' + inputText.value + '&input2=' + inputText2.value).then((resp) => {
    if (JSON.parse(JSON.stringify(resp.data)).respCode === '000000') {
      rna_seqList.value = JSON.parse(JSON.stringify(resp.data))['list']
    }
    loadtable1.value = false
  }).catch((err) => {
    loadtable1.value = false
    console.log(err)
  })
}

function showRnaseq2() {
  loadtable1.value = true
  $axios.get('http://bioinfo-sysu.com:8383/api/Transcript_search?input=' + inputText2.value).then((resp) => {
    if (JSON.parse(JSON.stringify(resp.data)).respCode === '000000') {
      rna_seqList.value = JSON.parse(JSON.stringify(resp.data))['list']
    }
    loadtable1.value = false
  }).catch((err) => {
    loadtable1.value = false
    console.log(err)
  })
}

const sortCorNum = ref(1)

function sortCor() {
  if (sortCorNum.value) {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].correlation)
      var nameB = parseFloat(b['fields'].correlation)
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    })
    sortCorNum.value = 0
  } else {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].correlation)
      var nameB = parseFloat(b['fields'].correlation)
      if (nameA < nameB) {
        return 1
      }
      if (nameA > nameB) {
        return -1
      }
      return 0
    })
    sortCorNum.value = 1
  }
}

const sortPNum = ref(1)

function sortP() {
  if (sortPNum.value) {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].pvalue)
      var nameB = parseFloat(b['fields'].pvalue)
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    })
    sortPNum.value = 0
  } else {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].pvalue)
      var nameB = parseFloat(b['fields'].pvalue)
      if (nameA < nameB) {
        return 1
      }
      if (nameA > nameB) {
        return -1
      }
      return 0
    })
    sortPNum.value = 1
  }
}

const sortAPNum = ref(1)

function sortAP() {
  if (sortAPNum.value) {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].adjpvalue)
      var nameB = parseFloat(b['fields'].adjpvalue)
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    })
    sortAPNum.value = 0
  } else {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].adjpvalue)
      var nameB = parseFloat(b['fields'].adjpvalue)
      if (nameA < nameB) {
        return 1
      }
      if (nameA > nameB) {
        return -1
      }
      return 0
    })
    sortAPNum.value = 1
  }
}

const loadtable1 = ref(false)

// const downloadFile = (fileName) => {
//   // 文件路径（假设文件名为data.csv）
//   const filePath = './file/' +fileName// 文件位于public目录下
//
//   // 创建隐藏的可下载链接
//   const link = document.createElement('a')
//   link.href = filePath
//   link.download = fileName // 设置下载文件名
//
//   // 添加到DOM并触发点击
//   document.body.appendChild(link)
//   link.click()
//
//   // 清理DOM
//   document.body.removeChild(link)
// };
</script>
<template>
  <div>
    <index-navbar/>
    <section class="relative w-full h-full py-40 min-h-screen">
      <div class="container mx-auto items-center flex flex-wrap">
        <div class="col-12 my-3">
          <el-breadcrumb :separator-icon="ArrowRight" style="font-size: 22px">
            <el-breadcrumb-item :to="{ path: '/' }"><i class="bi bi-house me-1"></i>Home</el-breadcrumb-item>
            <el-breadcrumb-item>Gene</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="col-12">
          <div class="py-10 border-t border-blueGray-200 text-center">
            <div class="flex flex-wrap justify-center">
              <div class="w-full lg:w-9/12 px-4">
                <p class="text-lg leading-relaxed text-blueGray-700">
                </p>
              </div>
            </div>
          </div>
        </div>
        <!--        <div class="col-md-6">-->
        <!--          <img :src="UMAP_celltype">-->
        <!--        </div>-->
        <!--        <div class="col-md-6">-->
        <!--          <img :src="edit_FeaturePlot">-->
        <!--        </div>-->
        <div class="col-12">
          <div class="d-flex flex-row justify-content-end align-items-center">
            <!--            <button-->
            <!--                class="bg-black text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"-->
            <!--                type="button"-->
            <!--                @click="downloadFile('GSE157007_edit_data.csv')">-->
            <!--              download-->
            <!--            </button>-->
            <div>
              <span>filter：</span>
              <input type="text" placeholder="search the editing" @input="inputInput" :value="inputText"
                     class="placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline"/>
            </div>
          </div>
          <table class="table table-striped table-bordered table-md align-middle mt-4"
                 style="text-align: left;table-layout:fixed" v-loading="loadtable1">
            <thead>
            <tr>
              <th scope="col" style="width: 13%">Gene ID</th>
              <th scope="col" style="width: 15%">Gene<br>info</th>
              <th scope="col" style="width: 10%">Transcript<br>ID</th>
              <th scope="col" style="width: 10%">Assembly<br>unit</th>
              <th scope="col" style="width: 9%">Gene<br>start</th>
              <th scope="col" style="width: 9%">Gene<br>end</th>
              <th scope="col" style="width: 8%">Strand</th>
              <th scope="col" style="width: 14%">Gene<br>type</th>
              <th scope="col" style="width: 12%">Canonical<br>Protein</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                <input type="text" placeholder="Search Gene ID" @input="inputInput" :value="inputText"
                       class="w-full placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline"/>
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">-
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                <input type="text" placeholder="Search Transcript ID" @input="inputInput2" :value="inputText2"
                       class="w-full placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline"/>
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">-
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">-
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">-
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">-
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">-
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">-
              </td>
            </tr>
            <tr v-for="(item,index) in rna_seqList.slice((currentPage-1)*PageSize,currentPage*PageSize)">
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                {{ item['fields'].gene_id }}
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                {{ item['fields'].gene_info }}
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                <router-link
                    :to="{name:'genedetail',query:{gene:item['pk']}}">
                  <el-link>{{ item['pk'] }}</el-link>
                </router-link>
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                {{ item['fields'].assembly_unit }}
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                {{ item['fields'].start }}
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                {{ item['fields'].end }}
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                {{ item['fields'].strand }}
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                {{ item['fields'].type }}
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                {{ item['fields'].canonical_protein }}
              </td>
            </tr>
            </tbody>
          </table>
          <!--    分页操作-->
          <el-pagination
              class="el-pager mt-3"
              style="--el-color-primary:#303034"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="pageSizes"
              :page-size="PageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="rna_seqList.length">
          </el-pagination>
        </div>
      </div>

    </section>

    <footer-component/>
  </div>
</template>
